import {
  Text,
  GreyGrey60,
  Primary13Regular,
  RadioButtonGroupField,
  RadioGroupField,
  TextAreaField,
  SimpleModal,
  Box,
  Flex
} from '@sequencehq/core-components'
import {
  FeedbackType,
  IssueSeverity,
  useShareFeedbackModal
} from 'components/ShareFeedbackModal/useShareFeedbackModal'
import { FeedbackAttachments } from 'components/ShareFeedbackModal/FeedbackAttachments'
import { FC } from 'react'

export const ShareFeedbackModal: FC<{
  onClose: () => void
}> = props => {
  const { queries, mutators } = useShareFeedbackModal({
    onClose: props.onClose
  })

  return (
    <SimpleModal
      isOpen
      title="Share feedback"
      data-testid="share-feedback-modal"
      onClose={mutators.closeModal}
      submitButtonText="Share feedback"
      submittingButtonText="Sharing..."
      submitting={queries.isSaving}
      submitDisabled={queries.isUploadingAttachments}
      onSubmit={mutators.saveFeedback}
      // The message field is a multiline textarea, so Enter should insert a
      // newline rather than submit the modal.
      disableSubmitOnEnter
    >
      <Flex flexDirection="column">
        <RadioButtonGroupField
          styles={{
            wrapper: {
              marginBottom: '24px'
            }
          }}
          {...queries.fieldsConfig.feedbackType}
          data-testid="share-feedback-modal.type"
          label=""
          fullWidth
          onChange={value =>
            queries.fieldsConfig.feedbackType.onChange(value as FeedbackType)
          }
        />
        {queries.feedbackType === 'issue' && (
          <RadioGroupField
            styles={{
              wrapper: {
                marginBottom: '24px'
              }
            }}
            {...queries.fieldsConfig.issueSeverity}
            data-testid="share-feedback-modal.severity"
            label=""
            value={queries.fieldsConfig.issueSeverity.value ?? ''}
            onChange={value =>
              queries.fieldsConfig.issueSeverity.onChange(
                value as IssueSeverity
              )
            }
          />
        )}
        <TextAreaField
          styles={{
            wrapper: {
              marginBottom: '8px'
            }
          }}
          {...queries.fieldsConfig.message}
          data-testid="share-feedback-modal.message"
          placeholder={
            queries.feedbackType === 'feedback'
              ? 'Type your feedback here...'
              : 'Give details about your issue here'
          }
        />
        <Box marginBottom="16px">
          <FeedbackAttachments
            attachments={queries.attachments}
            remainingSlots={queries.remainingAttachmentSlots}
            isUploading={queries.isUploadingAttachments}
            error={queries.attachmentError}
            onFilesPicked={mutators.onAttachmentsPicked}
            onUploadSuccess={mutators.onAttachmentUploadSuccess}
            onUploadFailure={mutators.onAttachmentUploadFailure}
            onUploadComplete={mutators.onAttachmentsUploadComplete}
            onRemove={mutators.removeAttachment}
          />
        </Box>
        <Text {...Primary13Regular} color={GreyGrey60}>
          Your feedback will be shared with the team and we'll get back to you
          as soon as possible.
        </Text>
      </Flex>
    </SimpleModal>
  )
}
